import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { UsageItem } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';
import { USAGE_TYPES } from '../../../Utils/Enums';
import {
  getPlaceholdersBasedOnUsageType,
  getAddUsageButtonLabel,
  getUserAddUsageButtonLabel,
} from '../../../Utils/Getter';

import styles from './UsagePercentageView.Styles';

function UsagePercentageView({
  usageData,
  images,
  percentageIndicatorFillColor,
  percentageIndicatorSecondaryColor,
  percentageIndicatorContainerStyle,
  percentageIndicatorShouldAnimate,
  containerStyle,
  usageValuesTextStyle,
  shouldShowAddUsageButton,
  onAddUsagePress,
  planId,
  isUser,
  toggleAddUsageModal,
  ...props
}) {
  const theme = useTheme();

  const getUsageLabel = usageType => {
    switch (usageType) {
      case USAGE_TYPES.DATA:
        return 'soho_plans_plan_card_data_label';
      case USAGE_TYPES.CALLS:
        return 'soho_plans_plan_card_calls_label';
      case USAGE_TYPES.SMS:
        return 'soho_plans_plan_card_sms_label';
      default:
        return usageType;
    }
  };

  const getUsageTestKey = usageType => {
    switch (usageType) {
      case USAGE_TYPES.DATA:
        return SohoFrameworkTestKeys.PlanAddDataBtn;
      case USAGE_TYPES.CALLS:
        return SohoFrameworkTestKeys.PlanAddCallBtn;
      case USAGE_TYPES.SMS:
        return SohoFrameworkTestKeys.PlanAddSMSBtn;
      default:
        return 'soho_plans_plan_card_usage_details_value';
    }
  };

  return (
    <View style={[styles.containerStyle(theme), containerStyle]}>
      {_map(usageData, (item, index) => {
        const {
          icon,
          isUnlimited,
          valuePercentage,
          usageType,
          remainingAmount: amount,
          remainingUnits: units,
          name,
        } = item;
        const showAddUsageButton = item?.shouldShowAddUsageButton ?? shouldShowAddUsageButton;
        const withAddUsageButton = !isUnlimited && showAddUsageButton;
        return (
          <UsageItem
            {...props}
            key={index}
            usageItemLabel={getUsageLabel(usageType)}
            // usageItemLabel={name}
            icon={icon}
            isUnlimitedUsage={isUnlimited}
            usageValuesPlaceholders={getPlaceholdersBasedOnUsageType({
              ...item,
              amount,
              units,
            })}
            usageValuesText="soho_plans_plan_card_usage_details_value"
            unlimitedUsageText="soho_plans_plan_card_unlimited_consumption"
            usagePercentageValue={valuePercentage}
            shouldShowAddUsageButton={withAddUsageButton}
            containerStyle={withAddUsageButton ? styles.usageItemContainerStyle : {}}
            images={images}
            addUsageButtonType={'secondary'}
            percentageIndicatorFillColor={percentageIndicatorFillColor}
            percentageIndicatorSecondaryColor={percentageIndicatorSecondaryColor}
            percentageIndicatorContainerStyle={percentageIndicatorContainerStyle}
            percentageIndicatorShouldAnimate={percentageIndicatorShouldAnimate}
            usageValuesTextStyle={usageValuesTextStyle}
            addUsageButtonTitle={
              isUser ? getUserAddUsageButtonLabel(usageType) : getAddUsageButtonLabel(usageType)
            }
            testID={getUsageTestKey(usageType)}
            addUsageButtonHandler={() => onAddUsagePress(item, toggleAddUsageModal, planId)}
            usageItemLabelTestKey={SohoFrameworkTestKeys.PlanProductTitle}
            usageValuesTextTestKey={SohoFrameworkTestKeys.PlanProductUsageValue}
            usagePercentageValueTestKey={SohoFrameworkTestKeys.PlanProductUsagePercentage}
          />
        );
      })}
    </View>
  );
}

UsagePercentageView.defaultProps = {
  shouldShowAddUsageButton: false,
  isUser: false,
};

UsagePercentageView.propTypes = {
  usageData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      usageType: PropTypes.string,
      icon: PropTypes.string,
      isUnlimited: PropTypes.bool,
      totalAmount: PropTypes.number,
      totalUnits: PropTypes.string,
      remainingAmount: PropTypes.number,
      remainingUnits: PropTypes.string,
      valuePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  images: PropTypes.object,
  percentageIndicatorFillColor: PropTypes.string,
  percentageIndicatorSecondaryColor: PropTypes.string,
  percentageIndicatorContainerStyle: ViewPropTypes.style,
  percentageIndicatorShouldAnimate: PropTypes.bool,
  isUser: PropTypes.bool,
  containerStyle: ViewPropTypes.style,
  usageValuesTextStyle: TextPropTypes.style,
  shouldShowAddUsageButton: PropTypes.bool,
  onAddUsagePress: PropTypes.func,
  planId: PropTypes.string,
  toggleAddUsageModal: PropTypes.func,
};

export default UsagePercentageView;
